import { ColumnsType } from 'antd/es/table';
import { Badge, PaginationProps, Space, Table, Typography } from 'antd';
import React, { useMemo } from 'react';
import { useTranslation } from '../../i18n/i18n';
import EmptyState from '../utils/EmptyState/EmptyState';
import useTenantStore, { ALL_TENANTS_VALUE, TENANT_COL_KEY } from '../../stores/tenant.store';

const { Text } = Typography;

export interface Alarm {
  id: string;
  statusAlarm: string;
  installation: string;
  address: string;
  admin: string;
  tenant: string;
  status: string;
  statusColor: string;
}

interface AlarmTableProps {
  alarms: Alarm[];
  pagination: PaginationProps;
  onChange: (pagination: PaginationProps) => void;
  loading?: boolean;
}

const AlarmTable = ({ alarms, pagination, onChange, loading }: AlarmTableProps) => {
  const { t } = useTranslation('alarms');
  const isAll = useTenantStore((state) => state.selectedTenant === ALL_TENANTS_VALUE);

  const columns = useMemo<ColumnsType<Alarm>>(() => {
    const tTable = (key: string) => t(`table.${key}`);
    return [
      {
        title: tTable('status'),
        dataIndex: 'status',
        key: 'status',
        render: (text: string, record: Alarm) => (
          <Space>
            <Badge color={record.statusColor} />
            <Text>{text}</Text>
          </Space>
        ),
      },
      {
        title: tTable('location'),
        dataIndex: 'installation',
        key: 'installation',
      },
      {
        title: tTable('address'),
        dataIndex: 'address',
        key: 'address',
      },
      {
        title: tTable('admin'),
        dataIndex: 'admin',
        key: 'admin',
      },
      {
        title: tTable('tenant'),
        dataIndex: 'tenant',
        key: TENANT_COL_KEY,
      },
      {
        title: tTable('statusAlarm'),
        dataIndex: 'statusAlarm',
        key: 'statusAlarm',
        render: () => (
          <Space>
            <Text>{t('table.active')}</Text>
          </Space>
        ),
        width: '20%',
      },
    ].filter((col) => !(col.key === TENANT_COL_KEY && !isAll));
  }, [t, isAll]);

  return (
    <Table
      size={'large'}
      columns={columns}
      dataSource={alarms}
      rowKey={(record) => record.id}
      pagination={pagination.total == null ? false : pagination}
      onChange={onChange}
      loading={loading}
      locale={{
        emptyText: <EmptyState title={t('empty.title')} description={t('empty.description')} />,
      }}
    />
  );
};

export default AlarmTable;
